import { render, staticRenderFns } from "./activate_temporary_agreement.vue?vue&type=template&id=2b1bb99c"
import script from "./activate_temporary_agreement.vue?vue&type=script&lang=js"
export * from "./activate_temporary_agreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports